import React from 'react';
import AIContext from '../../../pages/AIContext';

export const aiRoutes = [
  { path: '/ai-context', element: <AIContext /> },
  { path: '/ai-index', element: <AIContext /> },
  { path: '/api/page-context', element: <AIContext /> }
];
